import { BaseModel } from "model/BaseModel";
import EstagioUsuario from "./EstagioUsuario";
import Transacao from "model/suprimentos/Transacao";

export default class Estagio implements BaseModel {
    id: number;
    codigo: string | null = "";
    codigoEstagio: string;
    nome: string;
    estagioUsuarios: EstagioUsuario[];
    transacao: Transacao|null;
    temAcerto: string;

    constructor(
        id: number = 0,
        codigoEstagio: string = "",
        nome: string = "",
        estagioUsuarios: EstagioUsuario[] = [],
        transacao: Transacao|null = null,
        temAcerto: string = "N"
    ) {
        this.id = id;
        this.codigoEstagio = codigoEstagio;
        this.nome = nome;
        this.estagioUsuarios = estagioUsuarios;
        this.transacao = transacao;
        this.temAcerto = temAcerto;
    }
}